export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10365.4fda8e59.jpg";